import FilterButtons from '@/app/_components/widgets/listing/listingFilters/filterButtons';
import BlurredMapCTA from './BlurredMapCTA';

type ListingFiltersProps = {
  showMap: () => void;
  filterLight?: boolean;
};

const ListingFilters = ({ filterLight, showMap }: ListingFiltersProps) => {
  return (
    <>
      <FilterButtons filterLight={filterLight} />
      <BlurredMapCTA showMap={showMap} />
    </>
  );
};

export default ListingFilters;
